import { render, staticRenderFns } from "./event-card.vue?vue&type=template&id=8d87b462&scoped=true"
import script from "./event-card.vue?vue&type=script&lang=js"
export * from "./event-card.vue?vue&type=script&lang=js"
import style0 from "./event-card.vue?vue&type=style&index=0&id=8d87b462&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d87b462",
  null
  
)

/* custom blocks */
import block0 from "./event-card.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports